import { toNumber } from 'lodash';

export function formatCurrency(amount: number | string): string {
  return new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR'
  }).format(toNumber(amount));
}
